import Store from '@get-bridge/learn-legacy-shared/dist/core/Store';
import fetchLinks from './fetchLinks';

const LINKS_ID = 'self';

export default Store({
  fetch() {
    return fetchLinks().then(links => {
      this.cache.add({ ...links, id: LINKS_ID });
      return links;
    });
  },

  get() {
    return this.cache.get(LINKS_ID);
  },
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/mobile_app_links/MobileAppLinkStore.js